import React, { useEffect, useRef, useState } from 'react';

const SCHEMES = [
  { value: 'https://', label: 'https://' },
  { value: 'http://', label: 'http://' },
];

function splitUrlInput(raw) {
  const trimmed = String(raw || '').trim();
  const match = trimmed.match(/^(https?):\/\/(.*)$/i);
  if (!match) {
    return { scheme: 'https://', path: trimmed };
  }
  return {
    scheme: `${match[1].toLowerCase()}://`,
    path: match[2],
  };
}

function buildUrl(scheme, path) {
  const normalizedPath = String(path || '').trim().replace(/^https?:\/\//i, '');
  if (!normalizedPath) return '';
  return `${scheme}${normalizedPath}`;
}

export default function TutorialLinkInsertDialog({
  open,
  onConfirm,
  onCancel,
}) {
  const [scheme, setScheme] = useState('https://');
  const [path, setPath] = useState('');
  const pathRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    setScheme('https://');
    setPath('');
    const timer = window.setTimeout(() => pathRef.current?.focus(), 0);
    return () => window.clearTimeout(timer);
  }, [open]);

  useEffect(() => {
    if (!open) return undefined;
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        onCancel?.();
      }
      if (event.key === 'Enter') {
        event.preventDefault();
        const url = buildUrl(scheme, path);
        if (url) onConfirm?.(url);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [open, scheme, path, onConfirm, onCancel]);

  const handlePathChange = (event) => {
    const next = event.target.value;
    if (/^https?:\/\//i.test(next.trim())) {
      const parsed = splitUrlInput(next);
      setScheme(parsed.scheme);
      setPath(parsed.path);
      return;
    }
    setPath(next);
  };

  const handleConfirm = () => {
    const url = buildUrl(scheme, path);
    if (!url) return;
    onConfirm?.(url);
  };

  if (!open) return null;

  return (
    <div className="tutorial-apply-backdrop tutorial-apply-backdrop--top" role="presentation" onClick={onCancel}>
      <div
        className="tutorial-apply-modal tutorial-link-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="tutorial-link-title"
        onClick={(event) => event.stopPropagation()}
      >
        <h3 id="tutorial-link-title">插入链接</h3>
        <label className="tutorial-apply-modal__field">
          链接地址
          <div className="tutorial-link-input">
            <select
              className="tutorial-link-input__scheme"
              value={scheme}
              aria-label="链接协议"
              onChange={(event) => setScheme(event.target.value)}
            >
              {SCHEMES.map((item) => (
                <option key={item.value} value={item.value}>{item.label}</option>
              ))}
            </select>
            <input
              ref={pathRef}
              type="text"
              className="tutorial-link-input__path"
              value={path}
              placeholder="example.com/path"
              onChange={handlePathChange}
            />
          </div>
        </label>
        <div className="tutorial-apply-modal__actions">
          <button type="button" className="tutorial-manual__ghost-btn" onClick={onCancel}>
            取消
          </button>
          <button type="button" className="tutorial-manual__primary-btn" onClick={handleConfirm}>
            插入
          </button>
        </div>
      </div>
    </div>
  );
}
